import request from '@/lib/request/';

const baseUri = '/devices/';

/**
 * @returns {Promise}
 */
export function get() {
  return request({
    url: baseUri,
    method: 'get',
  });
}
